import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Column } from 'react-table'
import { BaseTable, IColumn } from 'src/components/BaseTable'
import NoResultsTable from 'src/components/NoResultsTable'
import { useConfigTable } from 'src/hooks/useConfigTable'
import { tableStore } from 'src/stores/TableStore'
import { resourceTabela } from 'src/utils/resourcesTabela'
import { AddRecord, Paper, TableContainer } from '../../components'
import Spacer from '../../components/Spacer'
import { unidadeNegocioStore } from './stores'
import { UnidadeNegocioDetail } from './types'
import { UnidadeNegocioColumns } from './UnidadeNegocioColumns'

interface Props {
  onDelete: (id: string) => void
  checks?: {
    ids: string[]
    onCheck: (id: string) => void
  }
  authorization?: {
    canCreate: boolean
    canDelete: boolean
    canUpdate: boolean
  }
}

export const UnidadeNegocioTable = observer(
  ({ onDelete, authorization }: Props) => {
    const { pathname } = useLocation()

    const KEY_TABLE = resourceTabela.UNIDADE_NEGOCIO
    useConfigTable(KEY_TABLE)
    const tableState = tableStore.getState(KEY_TABLE)
    const isTableReady =
      !unidadeNegocioStore.unidadeNegocio.isLoading &&
      tableState &&
      unidadeNegocioStore.unidadeNegocio.list.length

    const columns: Array<Column & IColumn> = useMemo(
      () => UnidadeNegocioColumns({ onDelete, authorization }),
      [onDelete, authorization]
    )

    const rows = unidadeNegocioStore.unidadeNegocio.list.map(
      ({ ...unidadeNegocio }: UnidadeNegocioDetail) => {
        return {
          ...unidadeNegocio
        }
      }
    )

    return (
      <>
        <Spacer y={4} />
        <Paper>
          <TableContainer
            loading={unidadeNegocioStore.unidadeNegocio.isLoading}
            totalCount={unidadeNegocioStore.unidadeNegocio.totalCount}
          >
            {isTableReady ? (
              <BaseTable
                keyTable={KEY_TABLE}
                columns={columns}
                hasConditionClickRow={false}
                linkWithRedirectClickRow={pathname}
                data={rows}
              />
            ) : (
              <NoResultsTable
                loading={unidadeNegocioStore.unidadeNegocio.isLoading}
              />
            )}
          </TableContainer>
        </Paper>

        <AddRecord path={pathname} authorization={authorization} />
      </>
    )
  }
)
